import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'SectionToolbar');
function SectionToolbar(_ref) {
  let {
    className,
    items = [],
    massiveToolbar,
    showMassiveToolbar
  } = _ref;
  const classes = useStyles();
  const leftItems = useMemo(() => items.filter(item => item.position === 'left'), [items]);
  const rightItems = useMemo(() => items.filter(item => item.position === 'right'), [items]);
  const rootClassNames = classnames(className, classes.root, {
    [classes.showMassiveToolbar]: showMassiveToolbar
  });
  return /*#__PURE__*/React.createElement("div", {
    className: rootClassNames
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.leftItems
  }, leftItems.map((item, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: classes.item
  }, item.component))), /*#__PURE__*/React.createElement("div", {
    className: classes.rightItems
  }, rightItems.map((item, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: classes.item
  }, item.component))), /*#__PURE__*/React.createElement("div", {
    className: classes.massiveToolbar
  }, massiveToolbar));
}
process.env.NODE_ENV !== "production" ? SectionToolbar.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    position: PropTypes.oneOf(['left', 'right']),
    component: PropTypes.node
  }))
} : void 0;
export default /*#__PURE__*/React.memo(SectionToolbar);